import { motion } from "framer-motion";
import { IMG } from "@/config";
import { SectionHeading } from "@/components/Section";
import { Reveal, stagger, fadeUp } from "@/components/Reveal";

const HIGHLIGHTS = [
  "Organized inventory system", "Trained warehouse team", "Safe material handling",
  "Accurate order preparation", "Commercial delivery workflow", "Quality-control procedures",
];

const SHOTS = [
  { src: IMG.warehouseShelves, cap: "Organized aisles", span: "row-span-2" },
  { src: IMG.workers, cap: "Trained team · safety gear" },
  { src: IMG.boxes, cap: "Packaging & staging" },
  { src: IMG.worker2, cap: "Order picking" },
  { src: IMG.logistics, cap: "Delivery preparation", span: "row-span-2" },
  { src: IMG.groceries, cap: "Stored by category" },
];

export default function WarehouseGallery() {
  return (
    <section data-testid="warehouse-gallery" className="py-24 md:py-32 bg-cream">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHeading
          chapter="09 / Operations"
          overline="Warehouse & Operations"
          title={<>A professionally managed wholesale operation</>}
          lead="Our warehouse operation is designed to support reliable stock management, accurate order picking and efficient deliveries for food businesses across Alberta."
          className="mb-14"
        />

        <div className="grid grid-cols-2 md:grid-cols-3 auto-rows-[180px] gap-4">
          {SHOTS.map((s, i) => (
            <Reveal key={i} delay={i * 0.06} className={s.span || ""}>
              <div className={`group relative h-full w-full overflow-hidden rounded-2xl border border-forest/15`}>
                <img src={s.src} alt={s.cap} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/70 to-transparent opacity-80" />
                <span className="absolute bottom-3 left-3 overline text-cream">{s.cap}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="flex flex-wrap gap-2.5 mt-8">
          {HIGHLIGHTS.map((h) => (
            <motion.span key={h} variants={fadeUp} className="rounded-full bg-white border border-forest/20 px-4 py-2 text-sm text-forest/80">{h}</motion.span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
